import httpClient from './httpClient';
import envVar from '../config/envVars';

interface UploadImageOptions {
  file: File;
  uploadFor: string;
  fileName: string;
  school: string;
}

export const uploadImageToS3 = async ({
  file,
  uploadFor,
  fileName,
  school
}: UploadImageOptions): Promise<any> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('uploadFor', uploadFor);
  formData.append('fileName', fileName);
  formData.append('school', school);

  const data = Object.fromEntries(formData.entries());

  const response: any = await httpClient.post(
    `${envVar.REACT_APP_BASE_API_URL}/attachments/upload`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  return response.url;
};
